export const MOBILE_APP_UNIVERSAL_LINK = 'https://onelink.to/n2esng';
export const INTERNET_BANKING_URL = 'https://auth.ardshinbank.am/Account/Login';
export const ARDSHINBANK_HOME_URL = 'https://ardshinbank.am/';